<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :is-no-changes="isNoChanges"
        :is-editorial-board="true"
        :selected-item.sync="journalEditorialBoard"
        :disabled="invalid"
        @save="saveJournalEditorialBoard"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-4 overflow-auto"
        >
          <v-card class="base-card shadow">
            <v-card-title class="headline accent--text"> Участие в работе редакционных коллегий журналов </v-card-title>
          </v-card>
          <!-- <EmployeeCard
            class="mt-4"
            :isShowMode="isShowMode"
            :selectedItem="journalEditorialBoard.commonWork.authors"
          /> -->
          <AuthorsCard
            title="Сотрудник"
            hide-not-found-author
            class="mt-4"
            :selected-item.sync="journalEditorialBoard.commonWork.authors"
            :is-show-mode="isShowMode"
            @updateInvalid="updateAuthorsInvalid"
            :is-editorial-board="true"
            hide-share
          />
          <MainInformationCard
            class="mt-4"
            :isShowMode="isShowMode"
            :selected-item.sync="journalEditorialBoard"
            @updateInvalid="updateEditorialBoardInvalid"
          />
          <CreatorCard :creator-name="journalEditorialBoard.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import MainInformationCard from './elements/MainInformationCard.vue'
import { workListHeight } from '@/mixins/workListHeight'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import { workMode, workTypeName, getWorkTypeIdByName } from '@/scripts/consts'
import TitleCard from '@/components/Works/elements/TitleCard.vue'
import { JournalEditorialBoard } from '../../models/JournalEditorialBoards.js'
import { journalEditorialBoardApi } from '../../api/index.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'JournalPage',

  data: () => ({
    journalEditorialBoard: new JournalEditorialBoard(),
    dataLoaded: true,
    isShowMode: false,
    isProcessMode: false,
    isEditMode: false,
    isNoChanges: true,
    editorialBoardInvalid: false,
    authorsInvalid: false
  }),
  components: {
    AuthorsCard,
    MainInformationCard,
    CreatorCard,
    TitleCard
  },
  mixins: [workListHeight],

  async created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    await this.getJournalEditorialBoard()
    await this.getWorkTypes()
    this.isNoChanges = true
  },
  computed: {
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),
    workTypeName() {
      return workTypeName
    },
    invalid() {
      return this.authorsInvalid || this.editorialBoardInvalid
    }
  },
  methods: {
    getWorkTypeIdByName,
    ...mapActions('workTypes', ['getWorkTypes']),
    goBack() {
      if (this.$router.history._startLocation !== this.$router.history.current.fullPath) this.$router.back()
      else this.$router.push('/journal-editorail-boards')
    },
    async saveJournalEditorialBoard(isThrowError = false) {
      try {
        this.journalEditorialBoard.employeePosition =
          this.journalEditorialBoard.commonWork.authors.list[0].employeePosition

        if (!this.journalEditorialBoard.id) {
          this.journalEditorialBoard.commonWork.workType = this.workTypeByName(workTypeName.JournalEditorialBoard)
        }

        const body = this.journalEditorialBoard.getForAPI()

        const data = this.journalEditorialBoard.id
          ? await journalEditorialBoardApi.update(body)
          : await journalEditorialBoardApi.create(body)
        this.journalEditorialBoard = new JournalEditorialBoard(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.error(e)
        if (isThrowError) throw new Error('Ошибка сохранения')
      }
    },
    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },
    updateEditorialBoardInvalid(val) {
      this.editorialBoardInvalid = val
      this.isNoChanges = false
    },
    async getJournalEditorialBoard() {
      this.dataLoaded = false
      try {
        if (this.$route.params?.id !== '0') {
          const data = await journalEditorialBoardApi.findById(this.$route.params?.id)
          this.journalEditorialBoard = new JournalEditorialBoard(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      } finally {
        this.dataLoaded = true
      }
    }
  },
  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },
  provide: function () {
    return {
      saveWork: this.saveJournalEditorialBoard
    }
  }
}
</script>
